import React, { Fragment, useEffect, useRef, useState } from 'react';
import { ArrowUp, Line } from '@yme/assets/icons';
import { Link } from '@yme/components/Link';
import { useWindowSize } from '@yme/hooks/index';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel4 } from '@yme/tokens/typography';
import { getClearedValue } from '@yme/utils/common';
import { SwitcherItem } from './SwitcherItem';
import { NavTitleIconStyled, UpButtonStyled, SwitcherIconStyled, NavSectionTitleStyled, NavSectionSubtitleStyled, NavTitleStyled, NavSectionStyled, } from './styled';
export const NavSection = ({ sectionView: { sectionRoot, leftSwitcherButton, rightSwitcherButton, items }, isDesktop, isRightToLeft, trackNavigation, }) => {
    const [isDisplayInColumn, setIsDisplayInColumn] = useState(false);
    const containerRef = useRef(null);
    const { isMobileView } = useWindowSize();
    const hasItems = items.length > 0;
    useEffect(() => {
        if (!isMobileView)
            return;
        const container = containerRef?.current;
        const items = container?.children;
        if (container && items) {
            const containerWidth = Math.ceil(container.getBoundingClientRect().width);
            let childrenWidth = 0;
            Array.from(items).forEach((item) => {
                childrenWidth = childrenWidth + Math.floor(item.getBoundingClientRect().width);
            });
            setIsDisplayInColumn(childrenWidth > containerWidth);
        }
    }, [isMobileView]);
    return (React.createElement(NavSectionStyled, { alignItems: "center" },
        isDesktop && !hasItems && (React.createElement(React.Fragment, null,
            React.createElement(UpButtonStyled, null,
                React.createElement(Link, { to: sectionRoot.link, onClick: trackNavigation(sectionRoot.link, 'breadcrumb') },
                    React.createElement(FlexWrapper, { flexDirection: "column" },
                        React.createElement(NavSectionTitleStyled, { color: colorCoreWhite1000 }, sectionRoot.title),
                        sectionRoot.subtitle && (React.createElement(NavSectionSubtitleStyled, { color: colorCoreWhite1000 }, sectionRoot.subtitle))))),
            React.createElement(NavTitleIconStyled, { pathFill: colorCoreWhite1000, type: ArrowUp, iconRotate: isRightToLeft ? 270 : 90 }))),
        React.createElement(FlexWrapper, { margin: isDisplayInColumn ? '-8px 0px' : undefined, ref: containerRef, isFullWidth: !isDesktop, flexDirection: isDisplayInColumn ? 'column' : 'row', alignItems: "center" },
            React.createElement(SwitcherItem, { switcherButton: leftSwitcherButton, hasItems: hasItems, trackNavigation: trackNavigation }),
            React.createElement(SwitcherIconStyled, { type: Line, iconRotate: isDisplayInColumn ? 90 : undefined }),
            React.createElement(SwitcherItem, { switcherButton: rightSwitcherButton, hasItems: hasItems, trackNavigation: trackNavigation })),
        isDesktop &&
            hasItems &&
            items.map((item) => (React.createElement(Fragment, { key: getClearedValue(item.link) },
                React.createElement(NavTitleIconStyled, { pathFill: colorCoreWhite1000, type: ArrowUp, iconRotate: isRightToLeft ? 270 : 90 }),
                item.isCurrentPage ? (React.createElement(NavTitleStyled, null,
                    React.createElement(HeadingLevel4, { color: colorCoreWhite1000 }, item.title))) : (React.createElement(UpButtonStyled, null,
                    React.createElement(Link, { to: item.link, onClick: trackNavigation(item.link, 'breadcrumb') },
                        React.createElement(HeadingLevel4, { color: colorCoreWhite1000 }, item.title)))))))));
};
